import { render, staticRenderFns } from "./CustomControls.vue?vue&type=template&id=34a551fc&"
import script from "./CustomControls.vue?vue&type=script&lang=js&"
export * from "./CustomControls.vue?vue&type=script&lang=js&"
import style0 from "./CustomControls.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports